import React from 'react'

import RouteLayout from '../../RouteLayout'
import { Buttons, Form, Table } from './Components'
import Spinner from '../../common/Spinner'
import { useSelector } from 'react-redux'


export default function GraduatesHEO () {
  
  const { loader, form, data, report_params } = useSelector(state => state.reports.summGraduatesOrientation)
  
  return (
    <RouteLayout title={'Сводная таблица по мероприятиям профориентации'}>
      <Form form={form}/>
      <Buttons visible={!!data} reportParams={report_params}/>
      {loader
        ? <Spinner />
        : <Table data={data} reportParams={report_params}/>
      }
    </RouteLayout>
  )
}
